// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-570a3354] .el-dialog__body {\n  text-align: center;\n  color: #333;\n}\n[data-v-570a3354] .el-dialog__body img {\n    margin-top: 14px;\n}\n[data-v-570a3354] .el-dialog__body h2 {\n    margin: 30px 0 10px 0;\n    font-size: 16px;\n    font-weight: 600;\n}\n[data-v-570a3354] .el-dialog__body p {\n    font-size: 14px;\n    margin-bottom: 14px;\n}\n[data-v-570a3354] .el-dialog__header .el-dialog__title {\n  font-size: 16px;\n  color: #333;\n  font-weight: 600;\n}\n", ""]);
// Exports
module.exports = exports;
